import script from "./VitaVacationType.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaVacationType.vue?vue&type=script&setup=true&lang=ts"

import "./VitaVacationType.vue?vue&type=style&index=0&id=72cb178c&lang=scss"

const __exports__ = script;

export default __exports__